export const place = {

   namespaced: true,

   state: {
      place: {
         administrative_area_level_1: '',
         administrative_area_level_2: '',
         administrative_area_level_3: '',
         administrative_area_level_4: '',
         country: '',
         latitude: null,
         longitude: null,
         locality: ''
      },
      queryString: ''
   },

   actions: {
      setSelectedPlace({commit}, payload) {
         commit('updatePlace', payload);
      },
      setQueryString({commit}, payload) {
         commit('updateQueryString', payload)
      }
   },

   mutations: {
      updatePlace(state, payload) {
         state.place = payload
      },
      updateQueryString(state, payload) {
         state.queryString = payload
      }
   }
};
